// extracted by mini-css-extract-plugin
module.exports = {"container":"LogItem_container__isztJ","log":"LogItem_log__2eGZJ"};